import React from 'react';
import { bool, string, number, shape } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const HeroFlattenImagePropTypes = {
  link: string,
  id: string,
  useDefaultAspectRatio: bool,
  image: shape({
    contentType: string,
    id: string,
    description: string,
    publishedDate: string,
    title: string,
    url: string,
  }),
  mobileImage: shape({
    contentType: string,
    id: string,
    description: string,
    publishedDate: string,
    title: string,
    url: string,
  }),
  layoutRendererPrerenderedChildIndex: number,
};

const HeroFlattenImageDefaultProps = {
  useDefaultAspectRatio: true,
  link: '',
  id: '',
  image: {},
  mobileImage: {},
  layoutRendererPrerenderedChildIndex: undefined,
};

export function CustomRenderedHeroFlattenImage({ channel }) {
  function HeroFlattenImage({
    link,
    id,
    useDefaultAspectRatio,
    image,
    mobileImage,
    layoutRendererPrerenderedChildIndex,
  }) {
    if (!image || !mobileImage) return null;

    const { title, description } = channel === 'mobile' ? mobileImage : image;

    const defaultAspectRatio = useDefaultAspectRatio
      ? 'default-aspect-ratio'
      : null;

    return (
      <a href={link} key={id}>
        <picture>
          <source
            className={styles(defaultAspectRatio, 'stretchy')}
            alt={description || title}
            srcSet={image.url}
            media="(min-width: 768px)"
          />
          <Image
            className={styles(defaultAspectRatio, 'stretchy')}
            alt={`Image for ${title}`}
            title={`Image for ${title}`}
            src={mobileImage.url}
            lazy={layoutRendererPrerenderedChildIndex !== 0}
          />
        </picture>
      </a>
    );
  }

  HeroFlattenImage.propTypes = HeroFlattenImagePropTypes;
  HeroFlattenImage.defaultProps = HeroFlattenImageDefaultProps;

  return HeroFlattenImage;
}
